import React from "react";
import { NotesList } from "./NotesList";
import {
  useGetRequestNotesQuery,
  useCreateRequestNoteMutation,
  useUpdateRequestNoteMutation,
} from "../../redux/reduxQuery/requestNotesApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";

interface RequestNotesListProps {
  requestId: string;
  noteType: "client" | "internal";
  medicalRequestId?: string;
  title?: string;
  readOnly?: boolean;
  embedded?: boolean;
  clientMode?: boolean;
  currentUserId?: string;
}

export const RequestNotesList = ({
  requestId,
  noteType,
  medicalRequestId,
  title,
  readOnly = false,
  embedded = false,
  clientMode = false,
  currentUserId,
}: RequestNotesListProps) => {
  const { data: notes = [], isLoading } = useGetRequestNotesQuery(
    requestId
      ? {
          requestId,
          noteType,
          medicalRequestId: medicalRequestId || undefined,
        }
      : skipToken
  );
  const [createNote, { isLoading: isCreating }] =
    useCreateRequestNoteMutation();
  const [updateNote] = useUpdateRequestNoteMutation();

  const displayTitle =
    title || (noteType === "client" ? "Client Notes" : "Notes");

  const handleCreate = async (body: string) => {
    await createNote({
      requestId,
      noteType,
      body,
      medicalRequestId: medicalRequestId || undefined,
    }).unwrap();
  };

  const handleUpdate = async (
    noteId: string,
    fields: { body?: string; isHighlighted?: boolean; isBanned?: boolean }
  ) => {
    await updateNote({ requestId, noteId, ...fields }).unwrap();
  };

  return (
    <NotesList
      notes={notes}
      isLoading={isLoading}
      isCreating={isCreating}
      title={displayTitle}
      readOnly={readOnly}
      embedded={embedded}
      clientMode={clientMode}
      currentUserId={currentUserId}
      onCreateNote={handleCreate}
      onUpdateNote={handleUpdate}
    />
  );
};
